<template>
  <div class="spotlight-qa">
    <template v-for="(item, i) in qaWithImages">
      <div v-if="item.type === 'qa'" :key="`qa-${i}`" class="spotlight-qa-pair">
        <div class="spotlight-question d-f">
          <p class="mute initial">Q:</p><p class="mute">{{ item.question }}</p>
        </div>
        <div class="spotlight-answer d-f">
          <p class="initial">A:</p><p>{{ item.answer }}</p>
        </div>
      </div>
      <div v-else-if="item.type === 'image'" :key="`img-${i}`" class="spotlight-inline-img">
        <img :src="item.url" :alt="item.caption || ''" class="spotlight-img-full" />
        <p v-if="item.caption" class="spotlight-caption mute font-small2 m-t-sm">
          {{ item.caption }}
        </p>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SpotlightQA',
  props: {
    qa: {
      type: Array,
      default: () => [],
    },
    inlineImages: {
      type: Array,
      default: () => [],
    },
    artistName: {
      type: String,
      required: true,
    },
  },
  computed: {
    artistFirstName() {
      return this.artistName.split(' ')[0]
    },
    qaWithImages() {
      const result = []
      this.qa.forEach((pair, i) => {
        result.push({ type: 'qa', ...pair })
        const img = this.inlineImages.find(img => img.afterQuestion === i + 1)
        if (img) result.push({ type: 'image', ...img })
      })
      return result
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/_classes.scss";

.spotlight-qa {
  display: flex;
  flex-direction: column;
  gap: $mg-desktop-2xl;
}

.spotlight-qa-pair {
  display: flex;
  flex-direction: column;
}

.spotlight-question, .spotlight-answer {
  // font-family: $font-reg;
  font-size: $h3-d;
  line-height: 1.5;
  margin: 0;

  @media #{$mobile} {
    font-size: $p1-mob;
  }
}
.initial {
  min-width: $h3-d;
}

.spotlight-inline-img {
  width: 100%;
}

.spotlight-img-full {
  width: 100%;
  display: block;
  object-fit: cover;
  background-color: $card-bg-color;
  min-height: 200px;
}

.spotlight-caption {
  line-height: 1.4;
}
</style>
